





























































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';

import { PARKING_LOT_DETAIL } from '../router-names';
// import { test } from '../../../api/parking-lot-management'

@Component({ name: 'ServiceOpenSetting' })
export default class ServiceOpenSetting extends Mixins(TableMixin) {
  searchType = 'name';
  searchValue = '';

  get tableColums() {
    return [
      {
        title: '序号',
        dataIndex: 'name'
      },
      {
        title: '车场名称',
        dataIndex: 'energy_alarm_level'
      },
      {
        title: '所属机构',
        dataIndex: 'energy_type'
      },
      {
        title: '项目名称',
        dataIndex: 'content'
      },
      {
        title: '所在地区',
        dataIndex: 'deal_suggest'
      },
      {
        title: '车库区域',
        dataIndex: 'send_person',
        customRender: (text: any) => {
          return `${text}个`;
        }
      },
      {
        title: '车位总数',
        dataIndex: 'is_use1',
        customRender: (text: any) => {
          return `${text}个`;
        }
      },
      {
        title: '临停车位数',
        dataIndex: 'is_use2',
        customRender: (text: any) => {
          return `${text}个`;
        }
      },
      {
        title: '车场业态',
        dataIndex: 'is_use3',
        customRender: (text: any) => {
          return `字典列表`;
        }
      },
      {
        title: '在场车辆',
        dataIndex: 'is_use4',
        customRender: (text: any) => {
          return `${text}辆`;
        }
      },
      {
        title: '在线状态',
        dataIndex: 'online',
        scopedSlots: { customRender: 'online' },
        customRender: (text: any) => {
          return text == 1 ? '在线' : '离线';
        }
      },
      {
        title: '时间对比',
        dataIndex: 'is_use'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  tableData: any[] = [
    {
      id: '111',
      is_use: 1,
      org_id: '组织标识',
      org_type: '组织类型',
      energy_type: '用能类型',
      name: '规则名称',
      rule: '报警条件',
      content: '报警内容',
      deal_suggest: '处理建议',
      send_person: [
        {
          staff_id: '11',
          name: 'xxx'
        }
      ],
      compare_type: 1,
      threshold_num: '阈值',
      energy_alarm_level: 1,
      online: 0
    }
  ];
  async mounted() {
    // const result = await test({})
  }
  addRuleTemp() {
    this.$router.push({
      name: PARKING_LOT_DETAIL
    });
  }

  /**
   * 添加设备分类
   */
  onAddCategory() {
    this.$router.push({
      name: this.routeNames.DEVICE_CATEGORY_CREATE
    });
  }
  toDetail(id: string) {
    this.$router.push({
      name: PARKING_LOT_DETAIL,
      params: {
        id: id
      }
    });
  }
}
